import { AxiosInstance } from '../configs/axios.config'

export type TaskState = 'PENDING' | 'STARTED' | 'SUCCESS' | 'FAILURE'

export type ArtifactResult = {
    artifact_type?: string
    filename?: string
    content_type?: string
    content_base64?: string
    [k: string]: any
}

export type TaskStatusResponse = {
    task_id: string
    state: TaskState
    result?: ArtifactResult | null
    error?: any
}

export async function enqueueSaleDocument(saleId: string, type: string) {
    const res = await AxiosInstance.get(`/documents/sale/${saleId}/${type}`)
    return res.data as { task_id: string; status?: string; task_name?: string }
}

export async function enqueueCompanyPricelist(
    companyId: string,
    vehicleId: string,
    withPrice = false
) {
    const res = await AxiosInstance.get(
        `/documents-company/company/${companyId}/vehicle/${vehicleId}/pricelist`,
        { params: { with_price: withPrice } }
    )
    return res.data as { task_id: string }
}

export async function enqueueCompanyStock(companyId: string) {
    const res = await AxiosInstance.get(
        `/documents-company/company/${companyId}/stock`
    )
    return res.data as { task_id: string }
}

export async function enqueueCompanySales(companyId: string) {
    const res = await AxiosInstance.get(
        `/documents-company/company/${companyId}/sales`
    )
    return res.data as { task_id: string }
}

export async function enqueueCompanyContacts(companyId: string) {
    const res = await AxiosInstance.get(
        `/documents-company/company/${companyId}/contacts`
    )
    return res.data as { task_id: string }
}

export async function postPublicEmail(payload: Record<string, any>) {
    const res = await AxiosInstance.post('/email/public/send', payload)
    return res.data as { task_id: string }
}

export async function getTaskStatus(taskId: string) {
    const res = await AxiosInstance.get(`/tasks/${taskId}`)
    return res.data as TaskStatusResponse
}
